import { FilteredFiles } from '../typings';

const getFilteredFiles = <T>(
  filesToFilter: any[],
  filter?: (x: T) => void
): FilteredFiles =>
  filesToFilter
    ?.map(([moduleName, files, ...opts]) => {
      if (!filter) return { moduleName, files, opts };

      const filteredFiles = files.filter(filter);
      if (filteredFiles && filteredFiles.length > 0)
        return { moduleName, files: filteredFiles, opts };

      return null;
    })
    .filter(Boolean);

export default getFilteredFiles;
